import { TokenInfo } from '../services'

export interface AuthState {
  user?: TokenInfo;
}
